import { render } from "./InquiryDesc.vue?vue&type=template&id=72803aff&scoped=true"
import script from "./InquiryDesc.vue?vue&type=script&lang=js"
export * from "./InquiryDesc.vue?vue&type=script&lang=js"

import "./InquiryDesc.vue?vue&type=style&index=0&id=72803aff&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72803aff"]])

export default __exports__